const input = {
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    email: 'E-posta Adresi',
    phone_number: 'Telefon Numarası',
    confirm_password: 'Şifreyi Doğrula',
    search_region_code: 'Bölge kodunu ara',
    backup_code: 'Yedek kod',
    code: 'Kod',
    label_with_optional: '{{label}} (İsteğe bağlı)',
    email_address: 'E-posta adresi',
    email_placeholder: 'E-postanızı girin',
    enter_email: 'E-postayı girin',
};
export default Object.freeze(input);
